import { createEndpoints } from '../../_helpers/utile/endpoint.helper';

export const INSPECTORS_GRID_ENDPOINTS = {
  V1: createEndpoints('v1', {
    EXPERT_FOCUS_AREAS: '/expert-focus-areas/',
    YEARS_OF_EXPERIENCE: '/years-of-experience/',
    USER_CERTIFICATES: (certificateID: number) => `/user-certificates/${certificateID}/`,
    USER_CERTIFICATE_DETAIL: (certificateID: number) => `/user-certificates/${certificateID}/`,
    INSPECTORS: '/inspectors/',
    INSPECTORS_NO_SLASH: '/inspectors',
    INSPECTORS_STATS: '/inspectors-stats/',
    INSPECTOR_DETAIL: (id: number) => `/inspectors/${id}/`,
    ACCOUNT_INFO: '/account-info/',
    CERTIFICATES: '/certificates/',
    CERTIFICATE_DETAIL: (certificateID: number) => `/certificates/${certificateID}`,
    CERTIFICATE_DETAIL_NO_SLASH: (certificateID: number) => `/certificates/${certificateID}`,
    FACILITIES: '/facilities/',
    EXSEP_PROFILE_STATUS: '/exsep-profile-status/',
    FILTERED_GROUPS: '/experts/filtered-groups/',
  }),
  V2: createEndpoints('v2', {
    CAREER_PATHS: '/experts/settings/career-paths/',
    REGISTRATION_AS: '/experts/settings/registration-as/',

  })
} as const;
